import React from 'react'
import FaceDetector from './FaceDetector'

export default function FaceDetectorPage() {
    return <FaceDetector />
}